"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeNames = exports.useOxygen = exports.OxygenProvider = exports.withDeprecation = exports.setLogger = exports.withTheme = exports.getTestAttributes = exports.getById = exports.get = exports.reset = exports.set = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_assign_1 = __importDefault(require("lodash.assign"));
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
const lodash_isobject_1 = __importDefault(require("lodash.isobject"));
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const constants = __importStar(require("@8x8/oxygen-constants"));
const oxygen_utils_1 = require("@8x8/oxygen-utils");
const OxygenProvider_1 = require("./OxygenProvider");
Object.defineProperty(exports, "OxygenProvider", { enumerable: true, get: function () { return OxygenProvider_1.OxygenProvider; } });
Object.defineProperty(exports, "useOxygen", { enumerable: true, get: function () { return OxygenProvider_1.useOxygen; } });
Object.defineProperty(exports, "themeNames", { enumerable: true, get: function () { return OxygenProvider_1.themeNames; } });
let configObject = (0, lodash_clonedeep_1.default)(constants);
let logger = console.warn; // eslint-disable-line no-console
const COMPONENT_TYPE_HOC = 'HOC';
/**
 * Extend the default theme with custom configuration.
 * @param {Object} newConfigs
 */
function set(newConfigs) {
    Object.keys(newConfigs)
        .filter((key) => key in newConfigs)
        .forEach((key) => {
        if ((0, lodash_isobject_1.default)(newConfigs[key]) && (0, lodash_isobject_1.default)(configObject[key])) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            configObject[key] = (0, lodash_assign_1.default)(configObject[key], newConfigs[key]);
        }
        else {
            /* The following item is completeley ignored by type-safe projects due to defined types */
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            configObject[key] = newConfigs[key];
        }
    });
}
exports.set = set;
/**
 * Reset the configuration to use the default values for all components
 */
function reset() {
    configObject = (0, lodash_clonedeep_1.default)(constants);
}
exports.reset = reset;
/**
 * Get the full theme configuration
 * @return {Object}
 */
function get() {
    return (0, lodash_clonedeep_1.default)(configObject);
}
exports.get = get;
/**
 * Get the configuration for a component/element by ID
 * @param {String} configId
 * @return {*}
 */
function getById(configId) {
    return configObject[configId];
}
exports.getById = getById;
/**
 * Get the test attributes object
 * @param getTestIdFn
 * @return {Object}
 */
function getTestAttributes(getTestIdFn) {
    return {
        'test-id': getTestIdFn,
        'data-test-id': getTestIdFn,
        'data-id': getTestIdFn,
    };
}
exports.getTestAttributes = getTestAttributes;
const themeMapper = {
    light: 'Novo',
    dark: 'NovoDark',
    classic: '',
};
/**
 * HOC to provide a theme to a component
 *
 * Logic:
 * 1. If using the OxygenProvider
 *  - get the themeName from the context ("light" or "dark") — if this is provided use this as base theme
 *  - get the globalComponentsOverride from the context — apply this on top of the base theme from above
 * 2. If not using the OxygenProvider, take the globalComponentTheme from the config object
 *    (this method will be deprecated in the future)
 *
 * @param {String} configProp Property name of configuration object
 */
function withTheme(WrappedComponent, configProp) {
    const WithTheme = react_1.default.forwardRef((props, ref) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { theme, ...rest } = props;
        // Get the theme from the context
        const context = (0, OxygenProvider_1.useOxygen)();
        // holds the component theme object, either from the global config object or from the context
        let computedTheme;
        // no context available — use the computedTheme from the config object
        if (!context) {
            /**
             * get and getById are both expensive as they both do deep cloning
             * use getById as it only clones a part of the config tree until
             * we get rid of the global config object and deep cloning
             * */
            computedTheme = getById(configProp);
        }
        else {
            // use from context
            const { themeName, globalComponentsOverride } = context;
            computedTheme = {
                ...constants[
                // maps to ${componentName}Novo or ${componentName}NovoDark from constants
                `${configProp}${themeMapper[themeName]}`],
                // apply global overrides if available for this particular component (if available)
                ...globalComponentsOverride?.[configProp],
            };
        }
        // Allow the local provided theme object to overwrite the global theme object (that comes from the config or from the context)
        const componentTheme = {
            ...computedTheme,
            ...theme,
        };
        const refs = WrappedComponent.componentType === COMPONENT_TYPE_HOC
            ? { ref }
            : { forwardedRef: ref };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return react_1.default.createElement(WrappedComponent, { ...rest, theme: componentTheme, ...refs });
    });
    WithTheme.displayName = WrappedComponent.displayName;
    const WithThemeNS = Object.assign(WithTheme, {
        name: WrappedComponent.name,
        componentType: COMPONENT_TYPE_HOC,
        propTypes: {
            theme: prop_types_1.default.object,
        },
        defaultProps: {
            theme: {},
        },
    });
    (0, hoist_non_react_statics_1.default)(WithThemeNS, WrappedComponent);
    return WithThemeNS;
}
exports.withTheme = withTheme;
function setLogger(newLogger) {
    if ((0, lodash_isfunction_1.default)(newLogger)) {
        logger = newLogger;
    }
}
exports.setLogger = setLogger;
function withDeprecation(WrappedComponent, deprecationMessage) {
    const WithDeprecation = react_1.default.forwardRef((props, ref) => {
        const refs = WrappedComponent.componentType === COMPONENT_TYPE_HOC
            ? { ref }
            : { forwardedRef: ref };
        return react_1.default.createElement(WrappedComponent, { ...props, ...refs });
    });
    WithDeprecation.displayName = WrappedComponent.displayName;
    const WithDeprecationNS = Object.assign(WithDeprecation, {
        componentType: COMPONENT_TYPE_HOC,
    });
    if ((0, oxygen_utils_1.isReactDevMode)()) {
        const message = deprecationMessage ||
            `Component "${WrappedComponent.displayName || WrappedComponent.name || ''}" is deprecated`;
        logger(`${message}; Please check Oxygen changelog for more info: https://oxygen.8x8.dev`);
    }
    (0, hoist_non_react_statics_1.default)(WithDeprecationNS, WrappedComponent);
    return WithDeprecationNS;
}
exports.withDeprecation = withDeprecation;
